import {
  Bold,
  Card,
  CardBody,
  Copy,
  Scroll,
  Title,
  Wrapper
} from "app/NativeComponents/common";
import React, { Component } from "react";
import PartnerInfo from "./PartnerInfo";
import PartnerMetrics from "./PartnerMetrics";
import { PartnerReports } from "./PartnerMetrics/reports";
import PartnerSignup from "./PartnerSignup";
import PromoCodes from "./PromoCodes";
import Stats from "./Stats";
import Users from "./Users";

class Body extends Component {
  render() {
    if (
      this.props.is_partner &&
      this.props.partner_info &&
      this.props.partner_stats.percent
    ) {
      return (
        <Wrapper style={{ display: "flex", flexFlow: "row wrap" }}>
          <Wrapper style={{ flex: 1, width: "50%" }}>
            <Card>
              <CardBody>
                <Title>{this.props.partner_info.title}</Title>
                <Copy>
                  <bold>Note:</bold> You will receive monthly payouts based on
                  cash-in.
                  {this.props.partner_stats.total_monthly_subscribers < 5
                    ? " You must have 5 or more total monthly subscribers to qualify for a monthly payout."
                    : ""}{" "}
                  You will receive 25%-50% (based on Silver, Gold, or Diamond
                  level) of monthly subscriptions for Basic and Professional
                  plans, and a flat 15% for Enterprise plans.
                </Copy>
              </CardBody>
            </Card>
            <Stats {...this.props} />
            <PartnerMetrics />
            <PartnerReports />
          </Wrapper>
          <Wrapper style={{ flex: 1, width: "50%" }}>
            <PartnerInfo {...this.props} />
            <PromoCodes {...this.props} />
            <Users {...this.props} />
          </Wrapper>
        </Wrapper>
      );
    }

    return <PartnerSignup {...this.props} />;
  }
}

export default Body;
